import React from 'react'
import { Container } from './Styled'
import Dashboard from './dashboard/Dashboard'
import BuilderLayout from '../layouts/builderLayout/BuilderLayout'

export const Statistic: React.FunctionComponent = props => {
    return (
        <BuilderLayout
            onBackDestination="/"
            title={'Indicateurs de performance'}
            subTitle={'Évaluez la performance de vos agents conversationnels et la qualité de votre service client'}
        >
            <Container>
                <Dashboard />
            </Container>
        </BuilderLayout>
    )
}

export default Statistic
